function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5999 5.6001L10.5368 25.2001C7.67862 22.8133 5.37768 19.819 3.79826 16.4309C2.21884 13.0428 1.3999 9.34455 1.3999 5.6001L26.5999 5.6001ZM26.5999 5.6001L13.0731 22.1054C10.6662 20.0954 8.72856 17.5739 7.39852 14.7208C6.06848 11.8677 5.37885 8.75332 5.37885 5.6001L26.5999 5.6001Z",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.36,
  cy: 10.3598,
  rx: 2.1,
  ry: 2.1,
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.3998C17.5 16.5596 16.5598 17.4998 15.4 17.4998C14.2403 17.4998 13.3 16.5596 13.3 15.3998C13.3 14.24 14.2403 13.2998 15.4 13.2998C16.5598 13.2998 17.5 14.24 17.5 15.3998Z",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.7599,
  cy: 8.95986,
  rx: 2.1,
  ry: 2.1,
  stroke: "#02BC4D",
  strokeWidth: 2
});

var SvgPizza = function SvgPizza(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPizza, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pizza.b4737158.svg";
export { ForwardRef as ReactComponent };